<script lang="ts">
  import type { WithElementRef } from 'bits-ui';
  import type { HTMLAttributes } from 'svelte/elements';
  import { cn } from '$lib/utils';

  let {
    ref = $bindable(null),
    class: className,
    children,
    ...restProps
  }: WithElementRef<HTMLAttributes<HTMLTableRowElement>> = $props();
</script>

<tr
  bind:this={ref}
  class={cn(
    'data-[state=selected]:bg-surface-2 hover:bg-surface-2/60 border-b border-border/60 transition-colors',
    className,
  )}
  {...restProps}
>
  {@render children?.()}
</tr>
